import { collection, updateDoc, doc, getDocs, query, orderBy, setDoc, Timestamp } from "firebase/firestore";
import { db } from "./firebase";
import { automationToFirestore, automationDataFromFirestore } from "../models/automation";
import { COLLECTIONS } from "./collections";
import AuditService, { AUDIT_ACTIONS, AUDIT_MODULES } from "./audit_service";

/**
 * AutomationService
 * CRUD de automações de mensagens.
 * Automações nunca são excluídas — apenas ativadas/desativadas.
 */
const AutomationService = {

    getAll: async (idTenant) => {
        try {
            const q = query(
                collection(db, "tenants", idTenant, COLLECTIONS.AUTOMATIONS),
                orderBy("trigger", "asc")
            );
            const snapshot = await getDocs(q);
            return snapshot.docs.map(d => automationDataFromFirestore(d.id, d.data()));
        } catch (error) {
            console.error("Erro ao listar automações:", error);
            throw error;
        }
    },

    save: async (formData, idTenant, authUser) => {
        if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

        try {
            const data = automationToFirestore(formData, idTenant, authUser);
            const colRef = collection(db, "tenants", idTenant, COLLECTIONS.AUTOMATIONS);

            if (formData.id) {
                const docRef = doc(db, "tenants", idTenant, COLLECTIONS.AUTOMATIONS, formData.id);
                await updateDoc(docRef, data);
                
                AuditService.log({
                    idTenant,
                    user: authUser,
                    module: AUDIT_MODULES.AUTOMATIONS,
                    action: AUDIT_ACTIONS.UPDATE,
                    entityId: formData.id,
                    entityName: data.name || data.trigger,
                    description: `Atualizou a automação "${data.name || data.trigger}"`
                });

                return { id: formData.id, ...data };
            } else {
                const newDocRef = doc(colRef);
                await setDoc(newDocRef, data);

                AuditService.log({
                    idTenant,
                    user: authUser,
                    module: AUDIT_MODULES.AUTOMATIONS,
                    action: AUDIT_ACTIONS.CREATE,
                    entityId: newDocRef.id,
                    entityName: data.name || data.trigger,
                    description: `Criou a automação "${data.name || data.trigger}"`
                });

                return { id: newDocRef.id, ...data };
            }
        } catch (error) {
            console.error("Erro ao salvar automação:", error);
            throw error;
        }
    },

    toggleActive: async (idTenant, automationId, active, authUser) => {
        try {
            const docRef = doc(db, "tenants", idTenant, COLLECTIONS.AUTOMATIONS, automationId);
            await updateDoc(docRef, {
                active,
                updatedAt: Timestamp.now(),
                updatedBy: {
                    uid: authUser?.uid || "system",
                    name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
                }
            });

            AuditService.log({
                idTenant,
                user: authUser,
                module: AUDIT_MODULES.AUTOMATIONS,
                action: AUDIT_ACTIONS.UPDATE,
                entityId: automationId,
                entityName: automationId,
                description: `Alterou o status da automação para "${active ? 'Ativo' : 'Inativo'}"`
            });
        } catch (error) {
            console.error("Erro ao alternar status:", error);
            throw error;
        }
    },
};

export default AutomationService;
